module.exports = __webpack_public_path__ + "static/img/one.6f50211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/1/one.png
// module id = dXlO
// module chunks = 1